<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color || 'currentColor'"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="happily-icon"
    :class="{ 'happily-icon--spin': spin }"
    :aria-hidden="ariaHidden"
    v-html="iconMarkup"
  />
</template>

<script>
import { ICON_PATHS } from './happily-icons.js'

export default {
  name: 'HappilyIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 18,
    },
    strokeWidth: {
      type: [Number, String],
      default: 2,
    },
    color: {
      type: String,
      default: null,
    },
    spin: {
      type: Boolean,
      default: false,
    },
    ariaHidden: {
      type: [Boolean, String],
      default: 'true',
    },
  },
  computed: {
    iconMarkup() {
      const markup = ICON_PATHS[this.name]
      if (!markup) {
        console.warn(`[HappilyIcon] Unknown icon "${this.name}"`)
        return ''
      }
      return markup
    },
  },
}
</script>

<style scoped>
.happily-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}

.happily-icon--spin {
  animation: happily-icon-spin 1s linear infinite;
}

@keyframes happily-icon-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
